import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Unified Password Regex matching Flutter mobile app validation rules:
 * - At least 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one digit
 * - At least one special character: !@#$%^&*()_-+=[]{};':"\|,.<>/?`~
 * - Must not contain spaces
 */
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?`~])\S{8,}$/;

/**
 * Returns a list of validation failure messages for the given password string,
 * matching Flutter app's `_passwordValidationMessages(pwd)`.
 */
export function getPasswordValidationMessages(pwd: string): string[] {
  const messages: string[] = [];
  if (!pwd || pwd.length === 0) {
    messages.push('Please enter your password');
    return messages;
  }
  if (pwd.length < 8) {
    messages.push('At least 8 characters');
  }
  if (!/[A-Z]/.test(pwd)) {
    messages.push('At least one uppercase letter');
  }
  if (!/[a-z]/.test(pwd)) {
    messages.push('At least one lowercase letter');
  }
  if (!/\d/.test(pwd)) {
    messages.push('At least one digit');
  }
  if (!/[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?`~]/.test(pwd)) {
    messages.push('At least one special character');
  }
  if (/\s/.test(pwd)) {
    messages.push('Password must not contain spaces');
  }
  return messages;
}

/**
 * Custom Angular ValidatorFn matching the Flutter password rules.
 */
export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // Handled by Validators.required
    }
    const messages = getPasswordValidationMessages(value);
    if (messages.length > 0) {
      return {
        passwordStrength: {
          messages,
          firstMessage: messages[0],
        },
      };
    }
    return null;
  };
}
